import React from 'react';
import routesConfig from './routes-config';
import { lazyImportWithRetry } from './utils/lazy-import';

import AdminPage from './views/AdminPage';
import TeamDetail from './views/TeamDetail';
import BillingPage from './views/BillingPage';
import { HelpCenter } from './views/HelpCenter';
import DashboardPage from './views/DashboardPage';
import { SessionDetail } from './views/SessionDetail';
import DeviceDetailPage from './views/DeviceDetailPage';
import { RequestVideo } from './views/RequestVideo/RequestVideo';
import PractitionerDetailPage from './views/PractitionerDetailPage';
import { AccountManagementPage } from './views/AccountManagementPage';

import TeamsTable from './components/Teams/TeamsTable';
import DevicesTable from './components/Devices/DevicesTable';
import ClientsTable from './components/Clients/ClientsTable';
import SessionsTable from './components/Sessions/SessionsTable';
import Organizations from './components/Organizations/Organizations';
import TreatmentsTable from './components/Treatments/TreatmentsTable';
import PractitionersTable from './components/Practitioners/PractitionersTable';

const CreateTreatmentWizard = lazyImportWithRetry(() =>
  import('./components/Treatments/CreateTreatmentWizard/CreateTreatmentWizard'),
);
const ClientDetail = lazyImportWithRetry(() =>
  import('./components/Clients/ClientDetail/ClientDetail'),
);

const componentMap = {
  AccountManagementPage,
  AdminPage,
  BillingPage,
  ClientDetail,
  ClientsTable,
  CreateTreatmentWizard,
  DashboardPage,
  DeviceDetailPage,
  DevicesTable,
  HelpCenter,
  Organizations,
  PractitionerDetailPage,
  PractitionersTable,
  RequestVideo,
  SessionDetail,
  SessionsTable,
  TeamDetail,
  TeamsTable,
  TreatmentsTable,
};

const routes = routesConfig.map(({ componentKey, ...routeConfig }) => {
  const component = componentMap[componentKey];

  if (!component) {
    throw new Error(
      `Component not found for route ${routeConfig.path} (${componentKey})`,
    );
  }

  return {
    ...routeConfig,
    component,
  };
});

export default routes;
